import axios from "axios";
import _ from "lodash";

const state = {
  // langInjected: false,
  languageOptions: [],
  static: {
    booking_statuses: [],
  },
};

const getters = {};

const mutations = {};

const actions = {
  injectStaticData({ commit }, staticData) {
    commit("SET", { static: staticData });
  },

  async handleLanguageChange({ state, dispatch }, staticData) {
    dispatch("injectStaticData", staticData);

    // Fetch config schema with new translations
    // (only if fetched before because otherwise it will be fetched when user navigates to page where it is actually required)
    if (state.configFormSchemaFetched) {
      dispatch("fetchConfigWithSchema", false);
    }
  },
};

export default {
  namespaced: false,
  state,
  getters,
  mutations,
  actions,
};
